<template>
  <div class="container">
    <div class="header">
      <div class="logo" @click="toindextoindex()">
        <img src="../assets/images/zhiyelogoendeee.jpg" alt="" />
      </div>
      <div class="search">
        <i class="el-icon-search"></i>
        <el-autocomplete
          class="inline-input"
          v-model="searchKeyword"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          placeholder="请输入城市名"
          @select="handleSelect"
        ></el-autocomplete>
        <el-button @click="searchCity" type="primary">搜 索</el-button>
      </div>
    </div>
    <div class="hotCity">
      <h3 class="hotCityTitle">热门城市</h3>
      <ul>
        <li
          v-for="item in hotCity"
          @click="selectChangedCity(item, item.province)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <div class="citySearch">
      <h3 class="hotCityTitle">城市选择</h3>
      <el-select
        v-model="chooseProvince"
        clearable
        placeholder="请选择"
        @change="selectChangedProvince"
        @visible-change="visibleChange"
      >
        <el-option
          v-for="item in searchProvinceList"
          :key="item.provinceid"
          :label="item.name"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
        @change="selectChangedCity"
        v-model="chooseCity"
        clearable
        placeholder="请选择"
      >
        <el-option
          v-for="item in searchCityList"
          :key="item.cityid"
          :label="item.name"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
    <div class="cityList">
      <ul class="cityListUl">
        <li class="item" v-for="(item, key) in provinceData" :key="key">
          <div class="firstletter">
            <h2>{{ key }}</h2>
          </div>
          <div class="cityData">
            <div
              v-if="item1.children.length > 0"
              v-for="item1 in item"
              :key="item1.cityid"
              class="province"
            >
              <span>{{ item1.label }}</span>
              <ul>
                <li
                  class="cityItem"
                  v-for="item2 in item1.children"
                  :key="item2.cityid"
                  @click="selectChangedCity(item2, item1.value)"
                >
                  {{ item2.value }}
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { get } from "js-cookie";
import https from "../http.js";
import qs from "qs";
import { TimeSelect } from "element-ui";
export default {
  data() {
    return {
      searchKeyword: "",
      chooseProvinceId: "",
      chooseProvince: "",
      chooseCity: "",
      restaurants: [],
      searchResultCity: [],
      searchProvinceList: [],
      searchCityList: [],
      hotCity: [],
      provinceData: [],
      value: "",
    };
  },
  created: function() {
    https
      .fetchPost("/index/get-province-city")
      .then((res) => {
        this.provinceData = res.data.data.province;
        this.hotCity = res.data.data.hotCity;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  mounted() {
    this.getProvinceList();
  },
  methods: {
    toindextoindex() {
      this.$router.push({ path: "/index" });
    },
    getAllCity() {
      https
        .fetchPost("/wechat-index/get-city-list")
        .then((res) => {
          this.restaurants = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSelect(item) {
      this.chooseProvince = item.province;
      localStorage.removeItem("locationResult");
      let param = {
        ad_info: {
          province: item.province,
          city: item.name,
          cityCode: item.cityid,
        },
      };
      localStorage.setItem("locationResult", JSON.stringify(param));
      setTimeout(() => {
        localStorage.removeItem("locationResult");
      }, 3600000); // 1小时 = 3600秒 = 3600000毫秒
      this.$router.push({ path: "/index" });
      window.location.reload();
    },
    querySearch(queryString, cb) {
      //根据城市名获取城市信息
      https
        .fetchPost("/wechat-index/get-city-list", { city: this.searchKeyword })
        .then((res) => {
          this.restaurants = res.data.data;
          cb(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    getProvinceList() {
      https
        .fetchGet("/wechat-index/get-province-list")
        .then((res) => {
          this.searchProvinceList = res.data.data;
          console.log(res, "province");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    visibleChange(e) {
      console.log(e);
      if (e) {
        if (this.chooseCity != "") {
          this.chooseCity = "";
        }
      }
    },
    selectChangedProvince(item) {
      this.chooseProvince = item.name;
      this.chooseProvinceId = item.provinceid;
      this.getCityList();
    },
    selectChangedCity(item, province) {
      const pro = province ? province : this.chooseProvince;
      localStorage.removeItem("locationResult");
      let param = {
        ad_info: {
          province: pro,
          city: item.value,
          cityCode: item.cityid,
        },
      };
      localStorage.setItem("locationResult", JSON.stringify(param));
      setTimeout(() => {
        localStorage.removeItem("locationResult");
      }, 3600000); // 1小时 = 3600秒 = 3600000毫秒
      this.$router.push({ path: "/index" });
      window.location.reload();
    },
    getCityList() {
      if (this.chooseProvinceId != "") {
        var param = { provinceId: this.chooseProvinceId };
        https
          .fetchPost("/wechat-index/get-city-list", qs.stringify(param))
          .then((res) => {
            this.searchCityList = res.data.data;
            console.log(res, "city");
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.$message.error("请先选择城市");
        return false;
      }
    },
    searchCity() {
      localStorage.removeItem("locationResult");
      if (this.restaurants.length == 0) {
        this.$message.error("请输入正确的相关城市名称");
        return false;
      }
      let param = {
        ad_info: {
          province: this.restaurants[0].province,
          city: this.restaurants[0].name,
          cityCode: this.restaurants[0].cityid,
        },
      };
      localStorage.setItem("locationResult", JSON.stringify(param));
      setTimeout(() => {
        localStorage.removeItem("locationResult");
      }, 3600000); // 1小时 = 3600秒 = 3600000毫秒
      this.$router.push({ path: "/index" });
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.container {
  padding: 0px 200px 100px;
}
.container h3 {
  margin-right: 30px;
}
.container .header {
  display: flex;
  align-items: center;
  height: 180px;
}
.container .header .logo {
  margin-right: 20px;
  cursor: pointer;
}
.container .header .logo img {
  width: 200px;
  height: 93px;
  margin-top: 5px;
}
.container .header .search {
  flex: 0.7;
  height: 50px;
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  padding: 5px 10px;
  background: #fff;
  border-radius: 5px;
}
.header .search .el-icon-search {
  font-size: 16px;
}

.header .search .el-autocomplete {
  width: 100%;
}
.header .search button {
  height: 44px;
  font-size: 18px;
}
.container .hotCity,
.container .citySearch {
  display: flex;
  height: 50px;
  align-items: center;
}
.container .hotCity ul {
  font-size: 18px;
}
.hotCity ul li {
  float: left;
  margin-right: 20px;
  cursor: pointer;
}
.container .citySearch .el-select {
  margin-right: 20px;
}

.container .cityList .cityListUl .cityItem {
  float: left;
  cursor: pointer;
  font-size: 15px;
}
.container .cityList {
  margin-top: 30px;
}
.cityList .cityListUl {
  border: 1px solid #eae5e5;
}
.cityList .cityListUl .item {
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eae5e5;
}
.cityList .cityListUl .firstletter {
  width: 60px;
  background: #eee;
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cityList .cityListUl .cityData {
  margin: 10px 0px 10px 60px;
  flex: 1;
}
.cityList .cityListUl .cityData .province {
  display: flex;
  align-items: center;
  padding: 10px;
}
.cityListUl .cityData .province span {
  font-size: 18px;
  white-space: nowrap;
  padding: 0px 20px;
  font-weight: 600;
}
.cityData .province ul {
  margin-right: 20px;
}
.cityData .province ul li {
  padding: 5px 10px;
}
</style>

<style>
.header .search .el-input .el-input__inner {
  height: 40px;
  font-size: 18px;
  border: none !important;
}
</style>
